
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/[id]",
      function () {
        return require("private-next-pages/share/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/[id]"])
      });
    }
  